<template>
  <div class="list">
    <div class="model-item" :class="{ choice: item.id === choice }" @click="$emit('update:choice', item.id)" v-for="(item, index) in list" :key="index">
      <div class="is-now" v-if="item.now">当前使用</div>
      <div class="model-price">
        <span class="unit">￥</span>
        <span class="wechatNumber">{{item.price}}</span>
      </div>
      <div class="info">
        <span>/{{item.month}}个月</span>
        <span class="wechatNumber" v-if="item.deposit * 1">/押金￥{{item.deposit}}</span>
        <img :src="IconFeedback" class="info-icon" v-if="item.deposit * 1" @click.stop="$emit('Toast')" />
      </div>
    </div>
  </div>
</template>

<script>
  import data from './data'
  import { SetImage } from '@/utils/Image'
  export default {
    data () {
      return {
        model_list: data
      }
    },
    props: {
      list: {
        type: Array,
        default: () => ([])
      },
      choice: null
    },
    computed: {
      ...SetImage(['IconFeedback'])
    }
  }
</script>

<style lang="less" scoped>
  .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .mt(.4rem);
    .model-item {
      .w(3rem);
      .h(1.7rem);
      .br(.1rem);
      box-sizing: border-box;
      border: 1px solid #c4c4c4;
      .mb(.24rem);
      .pl(.3rem);
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      &.choice {
        .bg(#f1fbff);
        border-color: #00b0f4;
        .info {
          .c(#b59065);
        }
      }
      .model-price {
        .c(#00b0f4);
        .fz(.28rem);
        display: flex;
        align-items: flex-end;
        .lh(1);
        .mb(.2rem);
        .unit {
          transform: translateY(-.06rem);
        }
        .wechatNumber {
          .fz(.48rem);
          .lh(1);
        }
      }
      .info {
        .h(.3rem);
        .flex-c();
        .fz(.24rem);
        .c(#999);
        .info-icon {
          .w(.3rem);
          .h(.3rem);
          .ml(.08rem);
        }
      }
    }
  }
</style>
